import styled from "styled-components";

export const AlertContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 2, 8, 0.18);
  z-index: 1000;
  min-width: 300px;
`;

export const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const AlertContent = styled.div`
  text-align: center;
  padding: 40px 20px;
  border-bottom: 1px solid #e0e0e0;
`;

export const AlertButton = styled.button`
  width: 100%;
  padding: 14px 0;
  border-radius: 4px;
  border: none;
  color: #ff6900;
  cursor: pointer;
`;